"use client"

import { FC, ReactNode } from 'react'
import { LanguageProvider } from '@/src/context/LanguageContext'
import CookieBanner from '@/src/components/CookieBanner'
import FloatingMessenger from '@/src/components/FloatingMessenger'

const ClientProviders: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <LanguageProvider>
      {children}
      <CookieBanner />
      <FloatingMessenger />
    </LanguageProvider>
  )
}

export default ClientProviders
